import React from "react";

export default function SpeedDialTooltipOpen() {
  return <></>;
}
